import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import { useMemo, useEffect } from 'react';
import { omitBy, isUndefined } from 'lodash';
export function useWarnDeprecated(deprecated) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var names = useMemo(function () {
    // Return only a name string of the deprecated props that are
    // defined so that we can compare in the effect without it
    // re-running unneccesarily
    return _Object$keys(omitBy(deprecated, isUndefined)).join(', ');
  }, [deprecated]);
  useEffect(function () {
    if (names.length > 0) {
      console.warn(["The props \"".concat(names, "\" are deprecated."), message].join(' '));
    }
  }, [names, message]);
}